(() => {
  // work/global-launch-options-2026-11-03/mixed-envelope/src/ceika-cart-lock.mjs
  var CART_LOCK_NAME = "ceika-configuration-cart";
  var queueKey = Symbol.for("ceika.configuration.cart.queue");
  function withCartLock(callback) {
    if (globalThis.navigator?.locks?.request) return globalThis.navigator.locks.request(CART_LOCK_NAME, callback);
    const next = (globalThis[queueKey] || Promise.resolve()).then(callback);
    globalThis[queueKey] = next.catch(() => {
    });
    return next;
  }

  // work/global-launch-options-2026-11-03/mixed-envelope/src/ceika-cart-envelope.mjs
  var WIRE_KEY = "_ceika_wire_v2";
  var TEXT_KEY = "_ceika_text_v2";
  var MAX_TEXT_BYTES = 8192;
  var MAX_TEXT_RECORDS = 12;
  var check = (ok, error) => {
    if (!ok) throw Error(error);
  };
  var object = (v) => v !== null && typeof v === "object" && !Array.isArray(v);
  var hex = (v) => typeof v === "string" && /^[a-f0-9]{16}$/.test(v);
  var canonical = (value) => JSON.stringify(sort(value));
  function sort(value) {
    if (Array.isArray(value)) return value.map(sort);
    return object(value) ? Object.fromEntries(Object.keys(value).sort().map((k) => [k, sort(value[k])])) : value;
  }
  function parseBounded(raw) {
    check(typeof raw === "string" && new TextEncoder().encode(raw).length <= MAX_TEXT_BYTES, "text_envelope_overflow");
    let at = 0;
    const space = () => {
      while (/[\x20\t\r\n]/.test(raw[at] || "\0")) at++;
    };
    const eat = (c) => {
      space();
      if (raw[at] === c) {
        at++;
        return true;
      }
      return false;
    };
    const string = () => {
      space();
      const start = at;
      check(raw[at++] === '"', "text_envelope_invalid");
      while (at < raw.length) {
        const c = raw[at++];
        if (c === "\\") {
          at++;
          continue;
        }
        if (c !== '"') continue;
        const result2 = JSON.parse(raw.slice(start, at));
        for (const ch of result2) {
          const n = ch.codePointAt(0);
          check(n < 55296 || n > 57343, "text_envelope_invalid");
        }
        return result2;
      }
      throw Error("text_envelope_invalid");
    };
    const value = (depth) => {
      check(depth <= 4, "text_envelope_invalid");
      space();
      if (raw[at] === '"') return string();
      if (eat("{")) {
        const entries = [], keys = /* @__PURE__ */ new Set();
        if (eat("}")) return {};
        do {
          const k = string();
          check(!keys.has(k) && eat(":"), "text_envelope_invalid");
          keys.add(k);
          entries.push([k, value(depth + 1)]);
          check(keys.size <= 84, "text_envelope_invalid");
          if (eat("}")) return Object.fromEntries(entries);
        } while (eat(","));
        throw Error("text_envelope_invalid");
      }
      const token = /^(?:true|false|null|-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)/.exec(raw.slice(at));
      check(token, "text_envelope_invalid");
      at += token[0].length;
      const result2 = JSON.parse(token[0]);
      check(typeof result2 !== "number" || Number.isFinite(result2), "text_envelope_invalid");
      return result2;
    };
    const result = value(0);
    space();
    check(at === raw.length, "text_envelope_invalid");
    return result;
  }
  function parseWireToken(raw) {
    check(typeof raw === "string" && raw.length <= 255, "wire_invalid");
    const [v, token, nonce, pairs, ...rest] = raw.split("|");
    check(v === "2" && !rest.length && hex(token) && hex(nonce) && typeof pairs === "string" && /^(?:[a-f0-9]{4})*$/.test(pairs), "wire_invalid");
    const choices = {};
    let last = -1;
    for (let i = 0; i < pairs.length; i += 4) {
      const k = pairs.slice(i, i + 2);
      check(parseInt(k, 16) > last, "wire_duplicate_or_unsorted_choice");
      last = parseInt(k, 16);
      choices[k] = pairs.slice(i + 2, i + 4);
    }
    return { token, nonce, choices };
  }
  function textRecord(text) {
    check(object(text) && Object.keys(text).length <= 84 && Object.values(text).every((v) => typeof v === "string"), "text_invalid");
    return structuredClone(text);
  }
  function parseTextEnvelope(raw) {
    if (raw == null || raw === "") return { v: 3, b: {} };
    const env = parseBounded(raw);
    check(object(env) && object(env.b) && Object.keys(env.b).length <= MAX_TEXT_RECORDS, "text_envelope_invalid");
    const keys = Object.keys(env).sort().join(",");
    check(env.v === 2 && keys === "b,r,v" && hex(env.r) || env.v === 3 && keys === "b,v", "text_envelope_invalid");
    const b = Object.fromEntries(Object.entries(env.b).map(([n, record]) => {
      check(hex(n), "wire_nonce_invalid");
      if (env.v === 2) return [n, { r: env.r, t: textRecord(record) }];
      check(object(record) && Object.keys(record).sort().join(",") === "r,t" && hex(record.r), "text_envelope_invalid");
      return [n, { r: record.r, t: textRecord(record.t) }];
    }));
    return { v: 3, b };
  }
  function writeTextEnvelope(envelope) {
    const normalized = parseTextEnvelope(JSON.stringify(envelope.v === 3 ? { v: 3, b: envelope.b } : envelope)), records = Object.values(normalized.b);
    const revisions = new Set(records.map((record) => record.r));
    if (revisions.size <= 1) for (const record of records) check(Object.values(record.t).every((value) => value.length <= 1024), "text_v2_field_limit");
    const raw = JSON.stringify(revisions.size > 1 ? normalized : { v: 2, r: records[0]?.r || envelope.r || "0000000000000000", b: Object.fromEntries(Object.entries(normalized.b).map(([nonce, record]) => [nonce, record.t])) });
    check(new TextEncoder().encode(raw).length <= MAX_TEXT_BYTES, "text_envelope_overflow");
    return raw;
  }
  function readWireText(raw, wire) {
    const parsed = typeof wire === "string" ? parseWireToken(wire) : wire;
    const record = parseTextEnvelope(raw).b[parsed.nonce];
    check(record, "text_record_missing");
    check(record.r === parsed.token, "configuration_outdated");
    return record.t;
  }
  function cartRecords(cart) {
    const env = parseTextEnvelope(cart.attributes?.[TEXT_KEY]), records = /* @__PURE__ */ new Map();
    for (const line of cart.items) {
      if (!Object.hasOwn(line.properties || {}, WIRE_KEY)) continue;
      check(!line.parent_relationship?.parent_key, "wire_on_child");
      const parsed = parseWireToken(line.properties[WIRE_KEY]);
      check(!records.has(parsed.nonce), "nonce_collision");
      readWireText(cart.attributes?.[TEXT_KEY], parsed);
      records.set(parsed.nonce, env.b[parsed.nonce]);
    }
    return records;
  }
  function stageTextRecord(raw, token, nonce, text, retainNonces) {
    check(hex(token) && hex(nonce), "wire_invalid");
    const env = parseTextEnvelope(raw), keep = retainNonces == null ? Object.keys(env.b) : retainNonces;
    for (const n of keep) check(env.b[n], "text_record_missing");
    const retained = new Set(keep), b = Object.fromEntries(Object.entries(env.b).filter(([n]) => retained.has(n)));
    const record = { r: token, t: textRecord(text) };
    check(!b[nonce] || canonical(b[nonce]) === canonical(record), "nonce_collision");
    b[nonce] = record;
    return writeTextEnvelope({ v: 3, b });
  }
  function decodeWireSelection(raw, textRaw, dictionary) {
    const parsed = parseWireToken(raw);
    check(parsed.token === dictionary.token, "configuration_outdated");
    const choices = {};
    for (const [k, v] of Object.entries(parsed.choices)) {
      const entry = dictionary.options[parseInt(k, 16)], value = entry?.[1][parseInt(v, 16)];
      check(entry && value !== void 0, "wire_choice_unknown");
      choices[entry[0]] = value;
    }
    return { schemaVersion: 1, revision: dictionary.revision, choices, text: readWireText(textRaw, parsed) };
  }

  // work/global-launch-options-2026-11-03/mixed-envelope/src/legacy-wire-v2.mjs
  var obj = (v) => v !== null && typeof v === "object" && !Array.isArray(v);
  var check2 = (b, e) => {
    if (!b) throw Error(e);
  };
  var cleanKey = (k) => typeof k === "string" && k.length > 0 && k.length <= 120 && !["__proto__", "constructor", "prototype"].includes(k);
  function textRecord2(text) {
    check2(obj(text) && Object.keys(text).length <= 40, "text_invalid");
    for (const [k, v] of Object.entries(text)) check2(cleanKey(k) && typeof v === "string" && v.length <= 1024, "text_invalid");
    return structuredClone(text);
  }
  function stageTextRecord2(raw, token, nonce, text, retainNonces) {
    return stageTextRecord(raw, token, nonce, textRecord2(text), retainNonces);
  }
  function decodeWireSelection2(raw, textRaw, d) {
    const selection = decodeWireSelection(raw, textRaw, d);
    selection.text = textRecord2(selection.text);
    return selection;
  }

  // work/global-launch-options-2026-11-03/mixed-envelope/src/active-cart-records.mjs
  function activeCartRecords(cart) {
    if (!cart.items.some((line) => Object.hasOwn(line.properties || {}, WIRE_KEY))) return /* @__PURE__ */ new Map();
    return cartRecords(cart);
  }

  // work/global-launch-options-2026-11-03/mixed-envelope/src/joint-entry-recovered.mjs
  (() => {
    var B = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298], w = (e, t) => e >>> t | e << 32 - t;
    function P(e) {
      let t = new TextEncoder().encode(e), r = Math.ceil((t.length + 9) / 64) * 64, i = new Uint8Array(r);
      i.set(t), i[t.length] = 128;
      let o = new DataView(i.buffer), a = t.length * 8;
      o.setUint32(r - 8, Math.floor(a / 4294967296)), o.setUint32(r - 4, a >>> 0);
      let l = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], n = new Uint32Array(64);
      for (let c = 0; c < r; c += 64) {
        for (let p = 0; p < 16; p++) n[p] = o.getUint32(c + p * 4);
        for (let p = 16; p < 64; p++) {
          let x = n[p - 15], I = n[p - 2], j = w(x, 7) ^ w(x, 18) ^ x >>> 3, _ = w(I, 17) ^ w(I, 19) ^ I >>> 10;
          n[p] = n[p - 16] + j + n[p - 7] + _ >>> 0;
        }
        let [d, u, m, f, s, h, y, O] = l;
        for (let p = 0; p < 64; p++) {
          let x = w(s, 6) ^ w(s, 11) ^ w(s, 25), I = s & h ^ ~s & y, j = O + x + I + B[p] + n[p] >>> 0, _ = w(d, 2) ^ w(d, 13) ^ w(d, 22), k = d & u ^ d & m ^ u & m, E = _ + k >>> 0;
          O = y, y = h, h = s, s = f + j >>> 0, f = m, m = u, u = d, d = j + E >>> 0;
        }
        for (let [p, x] of [d, u, m, f, s, h, y, O].entries()) l[p] = l[p] + x >>> 0;
      }
      return l.map((c) => c.toString(16).padStart(8, "0")).join("");
    }
    var D = 8192, G = 12, C = (e) => e !== null && typeof e == "object" && !Array.isArray(e), X = (e, t) => Object.prototype.hasOwnProperty.call(e, t), g = (e, t) => {
      if (!e) throw Error(t);
    }, L = (e) => e.toString(16).padStart(2, "0"), Y = (e) => new TextEncoder().encode(e).length, Q = (e) => typeof e == "string" && e.length > 0 && e.length <= 120 && !["__proto__", "constructor", "prototype"].includes(e);
    function Z(e) {
      return g(e?.schemaVersion === 2 && /^[a-f0-9]{16}$/.test(e.token) && Array.isArray(e.options), "wire_dictionary_invalid"), new Map(e.options.map(([t, r], i) => [t, { id: L(i), values: new Map(r.map((o, a) => [o, L(a)])) }]));
    }
    var F = (e) => (g(/^[A-Za-z0-9-]{8,80}$/.test(e || ""), "invalid_build_id"), P(e).slice(0, 16));
    function $(e, t, r) {
      g(/^[a-f0-9]{16}$/.test(r), "wire_nonce_invalid"), g(e?.revision === t.revision && C(e.choices), "configuration_outdated");
      let i = Z(t), o = [];
      for (let [l, n] of Object.entries(e.choices)) {
        let c = i.get(l);
        g(c && c.values.has(n), "wire_choice_unknown"), o.push(c.id + c.values.get(n));
      }
      o.sort();
      let a = "2|" + t.token + "|" + r + "|" + o.join("");
      return g(a.length <= 255, "wire_selection_too_large"), a;
    }
    function A(e) {
      g(typeof e == "string" && e.length <= 255 && /^[\x20-\x7e]*$/.test(e), "wire_invalid");
      let [t, r, i, o, ...a] = e.split("|");
      g(t === "2" && !a.length && /^[a-f0-9]{16}$/.test(r) && /^[a-f0-9]{16}$/.test(i) && /^(?:[a-f0-9]{4})*$/.test(o), "wire_invalid");
      let l = {}, n = -1;
      for (let c = 0; c < o.length; c += 4) {
        let d = o.slice(c, c + 2), u = parseInt(d, 16);
        g(u > n, "wire_duplicate_or_unsorted_choice"), n = u, l[d] = o.slice(c + 2, c + 4);
      }
      return { token: r, nonce: i, choices: l };
    }
    function M(e) {
      g(C(e) && Object.keys(e).length <= 40, "text_invalid");
      for (let [t, r] of Object.entries(e)) g(Q(t) && typeof r == "string" && r.length <= 1024, "text_invalid");
      return structuredClone(e);
    }
    const V = parseTextEnvelope, ee = writeTextEnvelope, W = stageTextRecord2, J = decodeWireSelection2;
    var b = (e, t) => {
      if (!e) throw Error(t);
    }, te = (e) => /^[1-9][0-9]*$/.test(String(e)), q = (e, t) => `gid://shopify/${e}/${t}`;
    var re = Object.freeze({ custom_pro_valving: { sku: "CEIKA-NATIVE-COIL-VALVING-PRO", baseMinor: 2e4, label: "Coilover Pro Racing valving" }, height_oem: { sku: "CEIKA-NATIVE-COIL-HEIGHT-OEM", baseMinor: 15e3, label: "Coilover factory ride height build" }, height_extra_low: { sku: "CEIKA-NATIVE-COIL-HEIGHT-LOW", baseMinor: 15e3, label: "Coilover extra-low ride height build" }, height_lifted: { sku: "CEIKA-NATIVE-COIL-HEIGHT-LIFT", baseMinor: 23e3, label: "Coilover lifted ride height build" }, front_mount: { sku: "CEIKA-NATIVE-COIL-MOUNT-FRONT", baseMinor: 5e3, label: "Front pillowball top mounts" }, rear_mount: { sku: "CEIKA-NATIVE-COIL-MOUNT-REAR", baseMinor: 5e3, label: "Rear pillowball top mounts" }, front_helpers: { sku: "CEIKA-NATIVE-COIL-HELPERS-FRONT", baseMinor: 7500, label: "Front helper springs" }, front_rear_helpers: { sku: "CEIKA-NATIVE-COIL-HELPERS-BOTH", baseMinor: 15e3, label: "Front and rear helper springs" } });
    function ne(e, t, r) {
      let i = { coil_height: e.height, coil_front_mount: e.frontMount, coil_rear_mount: e.rearMount, coil_helpers: e.helperScope, coil_color: e.color };
      t.core.setup === "custom" && (i.coil_valving = e.customValving);
      for (let o of ["front", "rear"]) t.springRates[o + "KgMm"] != null && (i["coil_" + o + "_rate"] = String(t.springRates[o + "KgMm"]));
      return t.core.damper === "2m" && (i.coil_reservoir = e.reservoirMount, e.reservoirMount === "remote" && (i.coil_hose = String(e.hoseLengthCm))), { schemaVersion: 1, revision: r.revision, choices: i, text: e.notes ? { notes: e.notes } : {} };
    }
    function S(e, t) {
      return !e || Object.entries(e).every(([r, i]) => i.includes(t[r]));
    }
    function R(e, t) {
      b(e.enabled === true && e.revision === t.revision, "policy_unavailable_or_outdated");
      let r = {}, i = (o) => {
        for (let a of o || []) S(a.when, t.choices) && (r[a.variantId] = (r[a.variantId] || 0) + a.units);
      };
      for (let o of Object.keys(t.choices)) b(Object.hasOwn(e.options, o), "unknown_option");
      i(e.mandatoryCharges);
      for (let [o, a] of Object.entries(e.options)) {
        let l = t.choices[o];
        if (!S(a.when, t.choices)) {
          b(l === void 0, "inactive_option");
          continue;
        }
        if (b(!a.required || l !== void 0, "required_option_missing"), l === void 0) continue;
        b(Object.hasOwn(a.values, l), "choice_not_allowed"), b(!a.lockedValue || a.lockedValue === l, "locked_option");
        let n = a.values[l];
        b(S(n.when, t.choices) && (!n.whenAny || n.whenAny.some((c) => S(c, t.choices))), "choice_incompatible"), i(n.charges);
      }
      for (let o of Object.keys(t.text || {})) b(Object.hasOwn(e.textFields || {}, o) && typeof t.text[o] == "string" && t.text[o].length <= (e.textFields[o].maxLength || 255), "invalid_text");
      return r;
    }
    function U({ binding: e, state: t, derived: r, quantity: i, buildId: o, cartText: a, retainNonces: l, marketPrices: n, allowLockedTest: c = false }) {
      b(e.family === "coilover" && te(e.productId), "binding_required"), b(c || e.purchaseEnabled === true, "purchasing_disabled"), b(Number.isInteger(i) && i >= 1 && i <= 20, "invalid_quantity"), b(r.configurationComplete && r.pricingCurrent, "configuration_not_ready");
      let d = e.fullPolicies.find((_) => _.ownerId === q("ProductVariant", r.core.variantId))?.policy;
      b(d && d.productId === q("Product", e.productId), "wrong_product_variant");
      let u = ne(t, r, e.dictionary), m = R(d, u), f = F(o), s = $(u, e.dictionary, f), h = W(a, e.dictionary.token, f, u.text, l), y = [String(r.core.variantId), ...Object.keys(m).map((_) => _.split("/").pop())], O = new Set(y.map((_) => n[_]?.currency));
      b(O.size === 1 && O.has(r.currency), "currency_mismatch");
      let p = { _ceika_wire_v2: s, _ceika_build: o, _ceika_family: "coilover", _ceika_role: "kit", _ceika_charge_ids: y.slice(1).join("|"), _ceika_charge_count: String(y.length - 1), _ceika_coilover_build: o, _ceika_coilover_role: "kit", _ceika_coilover_test: e.productId, Vehicle: e.vehicleName }, x = y.map((_, k) => {
        let E = n[_];
        return b(Number.isSafeInteger(E.price) && E.price > 0, "missing_market_price"), { variantId: _, unitMinor: E.price, quantity: i * (k === 0 ? 1 : m[q("ProductVariant", _)]) };
      }), I = x.reduce((_, k) => _ + k.quantity * k.unitMinor, 0);
      return b(I === Math.round(r.totalUsd * 100) * i, "quote_disagrees_with_charge_mapping"), { items: x.map((_, k) => ({ id: _.variantId, quantity: _.quantity, properties: k === 0 ? p : { _ceika_build: o, _ceika_family: "coilover", _ceika_role: "upgrade", _ceika_component: "coil-" + _.variantId, _ceika_coilover_build: o, _ceika_coilover_role: "upgrade", _ceika_coilover_test: e.productId, Upgrade: re[Object.entries(e.chargeBindings || {}).find(([, E]) => E.variantId === _.variantId)?.[0]]?.label || "Selected upgrade" }, ...k === 0 ? {} : { parent_id: String(r.core.variantId) } })), expected: x, totalMinor: I, currency: r.currency, attributes: { _ceika_text_v2: h }, selection: u };
    }
    var v = (e, t) => {
      if (!e) throw Error(t);
    };
    function T(e, t, r, i) {
      v(e.currency === t.currency, "The market changed. Refresh the configuration.");
      let o = e.items.filter((n) => n.properties?._ceika_build === i);
      v(o.length === t.expected.length, "Shopify did not return every selected component.");
      let a = o.find((n) => String(n.product_id) === String(r) && !n.parent_relationship);
      v(a, "The selected kit could not be verified.");
      let l = 0;
      for (let n of t.expected) {
        let c = o.find((d) => String(d.variant_id) === n.variantId);
        v(c && c.quantity === n.quantity && c.original_price === n.unitMinor, "Shopify pricing or quantity differs from the selected build."), c !== a && v(c.parent_relationship?.parent_key === a.key, "A paid extra is not attached to its kit."), l += c.final_line_price;
      }
      return v(l === t.totalMinor, "The Shopify total differs from the page quote."), { parent: a, totalMinor: l };
    }
    async function N({ binding: e, state: t, derived: r, quantity: i, buildId: o, marketPrices: a, displayProperties: l = {}, api: n }) {
      v(typeof n == "function", "Cart API missing");
      let c = await n("cart.js");
      v(c.currency === r.currency, "The market changed. Refresh prices before adding this build.");
      let d = [...activeCartRecords(c).keys()];
      let u = U({ binding: e, state: t, derived: r, quantity: i, buildId: o, marketPrices: a, cartText: d.length ? c.attributes?._ceika_text_v2 : "", retainNonces: d });
      Object.assign(u.items[0].properties, Object.fromEntries(Object.entries(l).filter(([f, s]) => (!f.startsWith("_") || f === "_ceika_display") && typeof s == "string")));
      for (let f of u.expected) {
        let s = await n("variants/" + f.variantId + ".js");
        v(s.available && s.price === f.unitMinor, "Shopify prices or availability changed. Refresh the configuration.");
      }
      let m = false;
      try {
        await n("cart/update.js", { attributes: u.attributes }), m = true, await n("cart/add.js", { items: u.items });
        let f = await n("cart.js"), s = T(f, u, e.productId, o);
        return v(c.items.every((h) => f.items.some((y) => y.key === h.key && y.quantity === h.quantity)), "The existing cart changed. Inspect the cart before retrying."), { cart: f, plan: u, ...s };
      } catch (f) {
        if (m) try {
          let s = await n("cart.js"), h = s.items.find((y) => y.properties?._ceika_build === o && !y.parent_relationship);
          h && await n("cart/change.js", { id: h.key, quantity: 0 });
        } catch (s) {
          throw Error("Inspect the cart before retrying. " + s.message);
        }
        throw f;
      }
    }
    function z(e) {
      return withCartLock(e);
    }
    function K(e, t, r) {
      let i = e.items.find((u) => u.properties?._ceika_build === r && !u.parent_relationship);
      v(i && String(i.product_id) === t.productId && i.properties?._ceika_family === "coilover", "This saved configuration could not be found.");
      let o = Object.entries(t.variantIdsByCore).find(([, u]) => String(u) === String(i.variant_id))?.[0];
      v(o, "The saved kit is no longer available.");
      let a = J(i.properties._ceika_wire_v2, e.attributes?._ceika_text_v2, t.dictionary), l = t.fullPolicies.find((u) => u.ownerId.endsWith("/" + i.variant_id))?.policy;
      v(l, "The saved configuration needs review."), R(l, a);
      let n = a.choices, c = o.lastIndexOf("_"), d = { setup: o.slice(0, c), damper: o.slice(c + 1), customValving: n.coil_valving || "standard", height: n.coil_height, frontMount: n.coil_front_mount, rearMount: n.coil_rear_mount, helperScope: n.coil_helpers, color: n.coil_color, reservoirMount: n.coil_reservoir || "not_applicable", hoseLengthCm: n.coil_hose ? Number(n.coil_hose) : null, springPair: "custom", springLinked: false, frontSpringRateKgMm: n.coil_front_rate ? Number(n.coil_front_rate) : null, rearSpringRateKgMm: n.coil_rear_rate ? Number(n.coil_rear_rate) : null, notes: a.text.notes || "" };
      return v(Number.isInteger(i.quantity) && i.quantity > 0 && i.quantity <= 20, "The saved quantity needs review."), { state: d, quantity: i.quantity, parent: i };
    }
    async function H(e, t) {
      let { api: r, binding: i } = e, o = await r("cart.js"), a = K(o, i, t), l = o.items.filter((s) => s.properties?._ceika_build === t), n = await N(e), c = await r("cart.js");
      if (!l.every((s) => c.items.some((h) => h.key === s.key && h.quantity === s.quantity))) throw await r("cart/change.js", { id: n.parent.key, quantity: 0 }), Error("The original configuration changed. Refresh the cart before editing.");
      let u;
      try {
        await r("cart/change.js", { id: a.parent.key, quantity: 0 });
      } catch (s) {
        u = s;
      }
      let m;
      try {
        m = await r("cart.js");
      } catch {
        throw Error("The update could not be confirmed. Inspect the cart before retrying.");
      }
      if (m.items.some((s) => s.properties?._ceika_build === t)) throw await r("cart/change.js", { id: n.parent.key, quantity: 0 }), u || Error("The original configuration could not be replaced.");
      let f = T(m, n.plan, i.productId, e.buildId);
      return v(o.items.filter((s) => s.properties?._ceika_build !== t).every((s) => m.items.some((h) => h.key === s.key && h.quantity === s.quantity)), "The other cart items changed. Inspect the cart."), { ...n, cart: m, ...f };
    }
    window.CeikaJointCommerce = { addCoilover: N, replaceCoilover: H, restoreCoilover: K, verifyCart: T, withCartLock: z };
  })();
})();
